import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { ErrorDTO } from "interface";
import { GENERAL_ENDPOINTS } from "core/constants/endpoints";
import instance from "core/constants/request";

const updateData = async (data: { text: string }) => {
  const formData = new FormData();
  formData.append("Text", data?.text);

  const res = await instance.put(GENERAL_ENDPOINTS.llms, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
};

export const useUpdateLLMS = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      GENERAL_ENDPOINTS.llms
    ],
    mutationFn: updateData,
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data.Message || "خطا در اعمال تغییرات"}`);
    },
    onSuccess: () => {
      toast.success(`تغییرات با موفقیت اعمال گردید`);
      queryClient.invalidateQueries({
        queryKey: [GENERAL_ENDPOINTS.llms],
      });
    },
  });
};
